import { groupBy, orderBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";
import { calcularQuantidadePelaDose, extrairUnidade } from "../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import { obterCodMedidaInoculante } from "../../atvsTodas/meta/estrutura_todas_atvs";
import { estruturaPlanejamentoInsumos } from "../../planejamentoInsumos/meta";
import { normalizarQuantidadeInsumos, viewQuantidadeInsumos } from "./normalizar";


export type typeInsumos = {
    insumo_nome: string;
    quantidade_total_view: string;
}

export type typeEstruturaCompraInsumos = {
    cod_propriedade: number;
    nome_propriedade: string;
    insumos: typeInsumos[];
};


export function estruturaCompraInsumos(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade_selecionada: number,
    gerar_por_propriedade: boolean
): typeEstruturaCompraInsumos[] | typeInsumos[] {

    if (!gerar_por_propriedade) {
        return estruturaCompraInsumosMesclados(data_atividades, data_propriedades, cod_propriedade_selecionada);
    }

    const estrutrua_insumos = estruturaPlanejamentoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, null, null);

    const add_info_propriedade_talhao = (estrutrua_insumos ?? []).map(i => {
        return {
            ...i,
            lista_insumos_por_talhao: i.lista_insumos_por_talhao.map(j => {
                return {
                    lista_insumos: j.lista_insumos.map(k => {
                        return {
                            ...k,
                            nome_talhao: j.nome_talhao,
                            cod_talhao: j.cod_talhao,
                            nome_propriedade: i.nome_propriedade,
                            cod_propriedade: i.cod_propriedade,
                            quantidade_por_area: Number(calcularQuantidadePelaDose(String(k.dosagem), Number(k.area_atividade), k.porcentagem_remonte)),
                            ref_name: `${k.cod_insumo}_____${k?.insumo_nome}_____${k.cod_medida}_____${k.cod_tipo}`,
                        }
                    })
                }
                //@ts-ignore
            }).map(l => l.lista_insumos).flat()
        }
    })

    const estrutura_compras: typeEstruturaCompraInsumos[] = add_info_propriedade_talhao.map(i => {

        const agrupar_insumos = groupBy(i.lista_insumos_por_talhao, 'ref_name');
        const estrutura_insumos = Object.entries(agrupar_insumos).map(([_key, insumos]) => {

            const normalizar_qtds = (insumos ?? []).map(i => {
                const cod_medida = i.cod_tipo === 8 ? obterCodMedidaInoculante(extrairUnidade(i.calculo_dosagem)) : i.cod_medida;
                // const norm = normalizarQuantidadeInsumos(i.quantidade, cod_medida);
                const norm = renormalizarQtdeTotalizar(i.quantidade_por_area, cod_medida);
                return {
                    ...i,
                    quantidade_normalizada: norm.quantidade,
                    nome_medida_normalizada: norm.medida,
                    cod_medida_normalizada: norm.cod_medida,
                }
            })
            const qtd_total = normalizar_qtds.reduce((acc, i) => acc + i.quantidade_normalizada, 0);
            return {
                insumo_nome: insumos[0].insumo_nome,
                quantidade_total_view: viewQuantidadeInsumos(qtd_total, normalizar_qtds[0].cod_medida_normalizada),

            }
        })

        return {
            nome_propriedade: i.nome_propriedade,
            cod_propriedade: i.cod_propriedade,
            insumos: estrutura_insumos
        }
    })

    return estrutura_compras ?? [];
};


export function estruturaCompraInsumosMesclados(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade_selecionada: number
): typeInsumos[] {

    const estrutrua_insumos = estruturaPlanejamentoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, null, null);

    const add_info_propriedade = (estrutrua_insumos ?? []).map(i => {
        return {
            lista_insumos_por_talhao: i.lista_insumos_por_talhao.map(j => {
                return {
                    lista_insumos: j.lista_insumos.map(k => {
                        return {
                            ...k,
                            nome_propriedade: i.nome_propriedade,
                            cod_propriedade: i.cod_propriedade,
                            nome_talhao: j.nome_talhao,
                            cod_talhao: j.cod_talhao,
                            quantidade_por_area: Number(calcularQuantidadePelaDose(String(k.dosagem), Number(k.area_atividade), k.porcentagem_remonte))
                        }
                    })
                }
            })
        }
        //@ts-ignore
    }).flatMap(i => i.lista_insumos_por_talhao.map(j => j.lista_insumos)).flat();

    const listar_insumos_com_info_necessaria: { insumo_nome: string, cod_medida_renormalizada: number, medida_renormalizada: string, quantidade_renormalizada: number, cod_tipo: number, ref_name: string }[] = (add_info_propriedade ?? []).map(i => {
        const cod_medida_insumo = i.cod_tipo === 8 ? obterCodMedidaInoculante(extrairUnidade(i.calculo_dosagem)) : i.cod_medida;
        const { quantidade, medida, cod_medida } = renormalizarQtdeTotalizar(i.quantidade_por_area, cod_medida_insumo)
        return {
            insumo_nome: i.insumo_nome,
            cod_medida_renormalizada: cod_medida,
            medida_renormalizada: medida,
            quantidade_renormalizada: quantidade,
            cod_tipo: i.cod_tipo,
            ref_name: `${i.insumo_nome}_____${medida}_____${i.cod_tipo}`,
        }
    });

    const agrupado_por_ref = groupBy(listar_insumos_com_info_necessaria, 'ref_name');

    const estrutura_totalizados = Object.entries(agrupado_por_ref).map(([_ref_name, insumos]) => {
        const soma_quantidades = insumos.reduce((acc, i) => acc + i.quantidade_renormalizada, 0);

        return {
            insumo_nome: insumos?.[0]?.insumo_nome,
            quantidade: soma_quantidades,
            medida: insumos?.[0]?.medida_renormalizada,
            quantidade_total_view: viewQuantidadeInsumos(soma_quantidades, insumos?.[0]?.cod_medida_renormalizada)
        }
    })

    // console.log("estrutura_totalizados: ", orderBy(estrutura_totalizados, 'insumo_nome', 'asc'))

    return estrutura_totalizados ?? [];
};


function renormalizarQtdeTotalizar(quantidade: number, cod_medida: number) {
    //L -> L
    if (cod_medida === 1) {
        return { quantidade: quantidade, medida: 'L', cod_medida: 1 };
    }
    //mL -> L
    if (cod_medida === 2) {
        return { quantidade: quantidade / 1000, medida: 'L', cod_medida: 1 };
    }
    //KG -> KG
    if (cod_medida === 3 || cod_medida === 6) {
        return { quantidade: quantidade, medida: 'Kg', cod_medida: 3 };
    }
    //g -> KG
    if (cod_medida === 4) {
        return { quantidade: quantidade / 1000, medida: 'Kg', cod_medida: 3 };
    }
    //t -> kg
    if (cod_medida === 7) {
        return { quantidade: quantidade * 1000, medida: 'Kg', cod_medida: 3 };
    }
    //sementes 
    if (cod_medida === 9) {
        return { quantidade: quantidade, medida: 'sementes', cod_medida: 9 };
    }

    return { quantidade: quantidade, medida: null, cod_medida: null };

}